import { JurisdictionIdFieldNames } from '@contracts/order/fields/JurisdictionIdFields';
import type { StringSchema } from 'yup';
import * as yup from 'yup';

export abstract class JurisdictionField {
  public static fieldName: string;
  public static validator: StringSchema = yup.string().trim().required();
}

export class caNSC extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.CaNSC;
}

export class abMVIDNumberField extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.AbMVIDNumber;
}

export class bcCustomerNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.BcCustomerNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{9}$/, {
      message: 'isBcCustomerNumberFormat',
      excludeEmptyString: true,
    });
}

export class bcFINNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.BcFINNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{5,6}$/, {
      message: 'isBcFINNumberFormat',
      excludeEmptyString: true,
    });
}

export class qcNEQNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.QcNEQNumber;
}

export class qcNIRNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.QcNIRNumber;
}

export class onCVORNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.OnCVORNumber;
  public static validator: StringSchema = yup.string().trim().required();
}

export class onPRIOAccountNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.OnPRIOAccountNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{5}$/, {
      message: 'isOnPRIOAccountNumberFormat',
      excludeEmptyString: true,
    });
}

export class nlMasterNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.NlMasterNumber;
}

export class usICC extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.UsICC;
}

export class usIFTA extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.UsIFTA;
}

export class usIRP extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.UsIRP;
}

export class usDotNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.UsDotNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{5,7}$/, {
      message: 'isUsDotNumberFormat',
      excludeEmptyString: true,
    });
}

export class federalIdNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.FederalIdNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{2}-\d{7}$/, {
      message: 'isFederalIdNumberFormat',
      excludeEmptyString: true,
    });
}

export class laNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.LaNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{6}-01$/, {
      message: 'isLaNumberFormat',
      excludeEmptyString: true,
    });
}

export class kentuckyNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.KentuckyNumber;
}

export class montanaNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.MontanaNumber;
}

export class oregonNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.OregonFileNumber;
}

export class tennesseeNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.TennesseeNumber;
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required()
    .matches(/^\d{5}$/, {
      message: 'isTennesseeNumberFormat',
      excludeEmptyString: true,
    });
}

export class texasNumber extends JurisdictionField {
  public static fieldName = JurisdictionIdFieldNames.TexasNumber;
}

export const jurisdictionIdsFields: Record<string, yup.Schema> = {
  [caNSC.fieldName]: caNSC.validator,
  [abMVIDNumberField.fieldName]: abMVIDNumberField.validator,
  [bcCustomerNumber.fieldName]: bcCustomerNumber.validator,
  [bcFINNumber.fieldName]: bcFINNumber.validator,
  [qcNEQNumber.fieldName]: qcNEQNumber.validator,
  [qcNIRNumber.fieldName]: qcNIRNumber.validator,
  [onCVORNumber.fieldName]: onCVORNumber.validator,
  [onPRIOAccountNumber.fieldName]: onPRIOAccountNumber.validator,
  [nlMasterNumber.fieldName]: nlMasterNumber.validator,
  [usICC.fieldName]: usICC.validator,
  [usIFTA.fieldName]: usIFTA.validator,
  [usIRP.fieldName]: usIRP.validator,
  [usDotNumber.fieldName]: usDotNumber.validator,
  [federalIdNumber.fieldName]: federalIdNumber.validator,
  [laNumber.fieldName]: laNumber.validator,
  [kentuckyNumber.fieldName]: kentuckyNumber.validator,
  [montanaNumber.fieldName]: montanaNumber.validator,
  [oregonNumber.fieldName]: oregonNumber.validator,
  [tennesseeNumber.fieldName]: tennesseeNumber.validator,
  [texasNumber.fieldName]: texasNumber.validator,
};

export const optionalJurisdictionIdsFields: Record<string, yup.Schema> =
  Object.fromEntries(
    Object.entries(jurisdictionIdsFields).map(([key, schema]) => [
      key,
      schema.notRequired(),
    ]),
  );
